import script from "./pageMain.vue?vue&type=script&setup=true&lang=js"
export * from "./pageMain.vue?vue&type=script&setup=true&lang=js"

import "./pageMain.vue?vue&type=style&index=0&id=9ffc312c&lang=scss&scoped=true"

import exportComponent from "D:\\WORK_At_Home\\kaikbSource\\restaurant-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ffc312c"]])

export default __exports__